"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Buckets_1 = require("./_Buckets");
var _Owner_1 = require("./_Owner");
exports.ListBucketsOutput = {
    type: "structure",
    required: [],
    members: {
        Buckets: {
            shape: _Buckets_1._Buckets
        },
        Owner: {
            shape: _Owner_1._Owner
        }
    }
};
//# sourceMappingURL=ListBucketsOutput.js.map